<template>
  <div class="modern-home">
    <div class="container">
      <!-- 桌面端侧边栏 -->
      <aside class="sidebar" v-if="!isMobile">
        <nav class="sidebar-nav">
          <div 
            class="nav-item" 
            :class="{ active: tabName === '全部' }"
            @click="clickTab('全部')">
            <div class="nav-icon">
              <i class="el-icon-menu"></i>
            </div>
            <span>全部</span>
          </div>
          <div 
            class="nav-item" 
            v-for="(item, index) in tabList" 
            :key="index"
            :class="{ active: item.name === tabName }"
            @click="clickTab(item.name)">
            <div class="nav-icon">
              <img :src="item.icon" :alt="item.name">
            </div>
            <span>{{ item.name }}</span>
          </div>
        </nav>
      </aside>

      <!-- 主内容区 -->
      <main class="main-content">
        <!-- 搜索区域 -->
        <section class="search-section">
          <div class="search-container">
            <h1 class="search-title">找众包服务推荐</h1>
            <p class="search-subtitle">来服务众包导航网站</p>
            
            <div class="search-box">
              <div class="search-input-wrapper">
                <el-input 
                  v-model="input"
                  placeholder="输入平台名称、服务关键词..."
                  class="modern-search"
                  @keyup.enter="searchName">
                </el-input>
                <button class="search-button" @click="searchName">
                  <i class="el-icon-search"></i>
                  <span v-if="!isMobile">搜索</span>
                </button>
              </div>
            </div>
            
            <p class="search-tips">搜索"家政"、"物流"、"软件开发"等关键词</p>
          </div>
        </section>

        <!-- 移动端分类导航 -->
        <section class="mobile-categories" v-if="isMobile">
          <div class="categories-scroll">
            <div 
              class="category-tab"
              :class="{ active: tabName === '全部' }"
              @click="clickTab('全部')">
              全部
            </div>
            <div 
              class="category-tab"
              v-for="(item, index) in tabList" 
              :key="index"
              :class="{ active: item.name === tabName }"
              @click="clickTab(item.name)">
              {{ item.name }}
            </div>
          </div>
        </section>

        <!-- 内容区域 -->
        <section class="content-section">
          <div class="content-container">
            <template v-if="SlList && SlList.length !== 0">
              <div 
                class="category-group" 
                v-for="(category, index) in SlList" 
                :key="index">
                <div class="category-header">
                  <div class="category-title">
                    <img :src="category.icon" v-if="!isMobile">
                    <h3>{{ category.name }}</h3>
                  </div>
                  <!-- PC端公告显示 -->
                  <div class="notice-section" v-if="index === 0">
                    <HelloWorld />
                  </div>
                </div>
                
                <div class="platforms-grid">
                  <div 
                    class="platform-card"
                    v-for="(platform, idx) in category.list" 
                    :key="idx"
                    @click="clickAddress(platform.url)">
                    <div class="card-content">
                      <div class="platform-header">
                        <div class="platform-logo">
                          <img :src="platform.logo" :alt="platform.name" :title="platform.desc">
                        </div>
                        <div class="platform-info">
                          <h4 class="platform-name">{{ platform.name }}</h4>
                          <p class="platform-desc">{{ platform.desc }}</p>
                        </div>
                      </div>
                      <div class="card-hover">
                        <i class="el-icon-link"></i>
                        <span>访问平台</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            
            <div class="empty-state" v-else>
              <el-empty description="暂无相关内容">
              </el-empty>
            </div>
          </div>
        </section>
      </main>
    </div>

    <!-- 返回顶部 -->
    <transition name="fade">
      <button 
        class="back-to-top" 
        @click="clickTop" 
        v-show="fShow2"
        aria-label="返回顶部">
        <i class="el-icon-arrow-up"></i>
      </button>
    </transition>
  </div>
</template>

<script>
import HelloWorld from "@/components/HelloWorld.vue"
import { getAll, getLb } from "../api/all.js"

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  },
  data() {
    return {
      tabList: [],
      tabName: '全部',
      fwNum: 0,
      fShow2: false,
      SlList: [],
      isMobile: null,
      input: ''
    }
  },
  async mounted() {
    this.checkMobile()
      
      // 先获取标签数据
      await this.getTab()
      
      // 短暂延迟确保DOM稳定
      await this.$nextTick()
      
      // 然后再获取主要内容
      await this.getSl()
      
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.checkMobile)
      
      // 强制浏览器重绘以稳定布局
      setTimeout(() => {
        this.$forceUpdate()
      }, 100)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    async clickTab(item) {
      this.tabName = item
      try {
        const params = item === '全部' ? {} : { type: item }
        const res = await getLb(params)
        this.SlList = res.data
      } catch (error) {
        console.error('获取分类数据失败:', error)
        this.$message.error('加载失败，请重试')
      }
    },
    clickAddress(url) {
      window.open(url, '_blank')
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.fShow2 = scrollTop > 500
    },
    clickTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    async getTab() {
      try {
        const res = await getAll()
        this.tabList = res.data
      } catch (error) {
        console.error('获取标签失败:', error)
      }
    },
    async getSl() {
      try {
        const res = await getLb()
        this.SlList = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    async searchName() {
      try {
        const params = this.input ? { searchName: this.input } : {}
        const res = await getLb(params)
        this.SlList = res.data
      } catch (error) {
        console.error('搜索失败:', error)
        this.$message.error('搜索失败，请重试')
      }
    }
  }
}
</script>
<style scoped lang="less">
/* HomeView.vue 优化移动端适配 */
.modern-home {
  min-height: 100vh;
  background: var(--bg-light);
  width: 100%;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  padding: 5px 20px 20px;
  align-items: flex-start;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 5px 15px 15px;
  }
  
  @media (max-width: 768px) {
    padding: 5px 10px 10px;
    gap: 10px;
    width: 100%;
    max-width: 100%;
  }
}

/* 侧边栏 - 优化置顶效果 */
.sidebar {
  width: 280px;
  flex-shrink: 0;
  position: sticky;
  top: 8px; /* 调整这个值来微调置顶位置 */
  align-self: flex-start;
  height: auto;
  max-height: calc(100vh - 120px); /* 限制最大高度，避免超出屏幕 */
  
  /* 关键：优化粘性定位性能 */
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  
  /* 平滑滚动 */
  scroll-behavior: smooth;
  
  /* 隐藏滚动条但保持功能 */
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 transparent;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
  
  @media (max-width: 1024px) {
    width: 100%;
    position: static;
    max-height: none;
    overflow-y: visible;
  }
}

.sidebar-nav {
  background: var(--bg-white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-sm);
  padding: 15px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  
  /* 确保内部元素稳定 */
  contain: layout style;
  
  @media (max-width: 1024px) {
    display: flex;
    overflow-x: auto;
    gap: 10px;
    padding: 12px;
    contain: none;
  }
}

/* 导航项 - 优化置顶状态下的样式 */
.nav-item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-dark);
  border: 2px solid transparent;
  min-height: 56px;
  box-sizing: border-box;
  position: relative;
  
  /* 优化性能 */
  transform: translateZ(0);
  will-change: transform;
  
  &:hover {
    background: rgba(62, 169, 246, 0.12);
    color: var(--primary);
    border-color: rgba(62, 169, 246, 0.2);
    transform: translateX(4px);
  }
  
  &.active {
    background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
    color: white;
    box-shadow: var(--shadow-md);
    border-color: #1a365d;
    transform: translateX(0);
    
    .nav-icon {
      background: rgba(255,255,255,0.25);
      transform: scale(1.05);
    }
  }
  
  @media (max-width: 1024px) {
    flex-shrink: 0;
    margin-bottom: 0;
    min-width: 120px;
    justify-content: center;
    flex-direction: column;
    min-height: 65px;
    
    &:hover {
      transform: translateY(-2px);
    }
  }
}

.nav-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background: var(--bg-light);
  transition: all 0.25s ease;
  flex-shrink: 0;
  
  img {
    width: 18px;
    height: 18px;
    display: block;
    transition: transform 0.2s ease;
  }
  
  i {
    font-size: 16px;
    transition: transform 0.2s ease;
  }
  
  .nav-item:hover & {
    background: rgba(62, 169, 246, 0.15);
    
    img, i {
      transform: scale(1.1);
    }
  }
  
  .nav-item.active & {
    img, i {
      transform: scale(1.1);
    }
  }
  
  @media (max-width: 1024px) {
    margin-right: 0;
    margin-bottom: 5px;
  }
}

/* 主内容区保持不变 */
.main-content {
  flex: 1;
  min-width: 0;
  margin-top: 0;
  width: 100%;
}

/* 搜索区域保持原有大尺寸样式 */
.search-section {
  background: var(--bg-white);
  border-radius: 16px;
  padding: 0px 40px;
  margin-bottom: 30px;
  color: var(--text-dark);
  text-align: center;
  box-shadow: var(--shadow-lg);
  border: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-bottom: 20px;
    border-radius: 12px;
    width: 100%;
  }
}

.search-container {
  position: relative;
  z-index: 1;
  width: 100%;
}

.search-title {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 15px;
  color: #1a365d;
  line-height: 1.1;
  text-shadow: 0 2px 4px rgba(0,0,0,0.05);
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
}

.search-subtitle {
  font-size: 1.3rem;
  color: var(--text-light);
  margin-bottom: 40px;
  line-height: 1.5;
  font-weight: 400;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 30px;
  }
}

.search-box {
  max-width: 700px;
  margin: 0 auto 20px;
  width: 100%;
}

.search-input-wrapper {
  display: flex;
  width: 100%;
  border-radius: 50px;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  border: 3px solid #e2e8f0;
  transition: all 0.3s ease;
  background: white;
  
  &:focus-within {
    border-color: var(--primary);
    box-shadow: 0 0 0 6px rgba(62, 169, 246, 0.2);
    transform: translateY(-2px);
  }
}

.modern-search {
  flex: 1;
  
  /deep/ .el-input__inner {
    height: 68px;
    border: none;
    border-radius: 0;
    padding: 0 30px;
    font-size: 18px;
    box-shadow: none;
    background: transparent;
    font-weight: 500;
    
    &:focus {
      box-shadow: none;
      background: transparent;
    }
    
    @media (max-width: 768px) {
      height: 60px;
      padding: 0 20px;
      font-size: 16px;
    }
  }
}

.search-button {
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  color: white;
  border: none;
  padding: 0 40px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  font-size: 18px;
  letter-spacing: 0.5px;
  
  &:hover {
    background: linear-gradient(135deg, #2d3748 0%, #1a365d 100%);
    transform: scale(1.02);
  }
  
  i {
    font-size: 20px;
  }
  
  @media (max-width: 768px) {
    padding: 0 25px;
    font-size: 16px;
    
    i {
      font-size: 18px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 0 20px;
    
    span {
      display: none;
    }
  }
}

.search-tips {
  font-size: 16px;
  color: var(--text-light);
  margin-top: 20px;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 14px;
    margin-top: 15px;
  }
}

/* 移动端分类 */
.mobile-categories {
  margin-bottom: 20px;
  background: var(--bg-white);
  border-radius: var(--border-radius);
  padding: 15px;
  box-shadow: var(--shadow-sm);
  width: 100%;
  box-sizing: border-box;
}

.categories-scroll {
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding-bottom: 5px;
  width: 100%;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 2px;
  }
}

.category-tab {
  padding: 10px 20px;
  background: var(--bg-light);
  border-radius: 25px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-dark);
  flex-shrink: 0;
  border: 2px solid transparent;
  
  &:hover {
    background: rgba(62, 169, 246, 0.1);
    color: var(--primary);
    border-color: rgba(62, 169, 246, 0.3);
  }
  
  &.active {
    background: #1a365d;
    color: white;
    border-color: #1a365d;
    box-shadow: var(--shadow-md);
  }
}

/* 内容区域 */
.content-section {
  background: var(--bg-white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  margin-top: 0;
  width: 100%;
}

.content-container {
  padding: 0;
  width: 100%;
}

.category-group {
  padding: 25px 30px;
  border-bottom: 1px solid #f0f0f0;
  width: 100%;
  box-sizing: border-box;
  
  &:last-child {
    border-bottom: none;
  }
  
  @media (max-width: 768px) {
    padding: 20px 15px;
  }
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  width: 100%;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    margin-bottom: 20px;
  }
}

.category-title {
  display: flex;
  align-items: center;
  gap: 12px;
  
  img {
    width: 32px;
    height: 32px;
  }
  
  h3 {
    font-size: 1.5rem;
    color: var(--text-dark);
    margin: 0;
    font-weight: 700;
  }
}

/* PC端公告显示 */
.notice-section {
  width: 400px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    width: 100%;
  }
}

.platforms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}

.platform-card {
  background: var(--bg-white);
  border: 1px solid #f0f0f0;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  width: 100%;
  
  &:hover {
    border-color: var(--primary);
    transform: translateY(-3px);
    box-shadow: var(--shadow-lg);
    
    .card-hover {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

.card-content {
  padding: 20px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.platform-header {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  width: 100%;
}

.platform-logo {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
  background: var(--bg-light);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.platform-info {
  flex: 1;
  min-width: 0;
  width: 100%;
}

.platform-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-dark);
  margin: 0 0 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.platform-desc {
  font-size: 0.9rem;
  color: var(--text-light);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
  width: 100%;
}

.card-hover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 54, 93, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  opacity: 0;
  transform: translateY(8px);
  transition: all 0.3s ease;
  width: 100%;
  
  i {
    font-size: 28px;
    margin-bottom: 10px;
  }
  
  span {
    font-weight: 700;
    font-size: 16px;
  }
}

/* 空状态 */
.empty-state {
  padding: 60px 20px;
  text-align: center;
  width: 100%;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: var(--shadow-xl);
  transition: all 0.3s ease;
  z-index: 1000;
  font-size: 20px;
  
  &:hover {
    background: linear-gradient(135deg, #2d3748 0%, #1a365d 100%);
    transform: translateY(-3px) scale(1.05);
    box-shadow: var(--shadow-2xl);
  }
  
  @media (max-width: 768px) {
    right: 20px;
    bottom: 20px;
    width: 50px;
    height: 50px;
    font-size: 18px;
  }
}

/* 动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 新增：侧边栏置顶优化 */
.sidebar {
  /* 确保在滚动时保持层级 */
  z-index: 99;
}

/* 确保侧边栏内容加载时的稳定性 */
.sidebar-nav {
  /* 预占位高度，避免内容加载时的跳动 */
  min-height: 400px;
}

/* 加载状态 */
.sidebar.loading {
  opacity: 0.7;
  pointer-events: none;
}

/* 响应式优化 */
@media (min-width: 1025px) {
  .sidebar {
    /* 在大屏幕上优化置顶效果 */
    transition: transform 0.3s ease;
  }
  
  /* 当页面滚动到顶部时，侧边栏稍微下移避免与header重叠 */
  .modern-home.scrolled .sidebar {
    top: 100px;
  }
}

/* 移动端特定优化 */
@media screen and (max-width: 768px) {
  .modern-home {
    width: 100%;
    overflow-x: hidden;
  }
  
  .container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }
  
  .main-content {
    width: 100%;
    max-width: 100%;
  }
  
  .search-section,
  .mobile-categories,
  .content-section {
    width: 100%;
    max-width: 100%;
  }
  
  /* 防止内容溢出 */
  .platforms-grid,
  .category-group,
  .content-container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }
}

/* 打印样式优化 */
@media print {
  .sidebar {
    position: static;
    page-break-inside: avoid;
  }
}
</style>